import { lazy, Suspense } from 'react';
import { useActiveRater } from '../lib/ActiveRaterContext';

const PersonPicker = lazy(() => import('./PersonPicker').then(module => ({ default: module.PersonPicker })));

export function ActiveRaterPicker({ className = 'w-60' }: { className?: string }) {
  const { activeRaterPid, caylentPeople, isLoading, setActiveRaterPid } = useActiveRater();

  return (
    <div
      className={`${className} rounded-md border`}
      style={{ borderColor: 'var(--border)', background: 'var(--card)' }}
    >
      <Suspense fallback={null}><PersonPicker
        people={caylentPeople}
        value={activeRaterPid}
        onChange={setActiveRaterPid}
        placeholder={isLoading ? 'Loading reps…' : 'Select identity'}
      /></Suspense>
    </div>
  );
}

export function ActiveRaterLabel() {
  const { activeRater, isLoading } = useActiveRater();
  return <span className="flex min-w-0 max-w-36 flex-col text-xs max-[700px]:max-w-16 max-[700px]:text-[10px] leading-tight text-white/80" aria-label="Active identity">
    <span className="text-[9px] uppercase tracking-wide text-white/60 max-[700px]:hidden">Logged in as</span>
    <span className="truncate">{activeRater?.name ?? (isLoading ? 'Loading…' : 'No identity selected')}</span>
  </span>;
}
